var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.06,
    cy: 38.06,
    r: 38.06,
    fill: "#5F88F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9989 46.9529V52.3724C56.0009 52.8755 55.8977 53.3735 55.6957 53.8344C55.4938 54.2954 55.1976 54.7092 54.8261 55.0493C54.4546 55.3895 54.0161 55.6484 53.5385 55.8096C53.061 55.9708 52.555 56.0306 52.0529 55.9853C46.483 55.3813 41.1328 53.4818 36.432 50.4394C32.0586 47.6659 28.3507 43.9653 25.5716 39.6005C22.5125 34.8878 20.6088 29.5221 20.0147 23.9383C19.9695 23.4388 20.0289 22.9353 20.1894 22.4599C20.3498 21.9846 20.6076 21.5478 20.9465 21.1773C21.2853 20.8069 21.6977 20.5109 22.1574 20.3082C22.6172 20.1056 23.1141 20.0006 23.6167 20.0002H29.0469C29.9254 19.9915 30.777 20.302 31.443 20.8737C32.1091 21.4453 32.5441 22.2392 32.6671 23.1073C32.8963 24.8417 33.3213 26.5446 33.9341 28.1835C34.1777 28.8301 34.2304 29.5328 34.086 30.2084C33.9416 30.884 33.6063 31.5041 33.1196 31.9952L30.8208 34.2895C33.3975 38.8121 37.1496 42.5567 41.6812 45.1284L43.98 42.8341C44.4722 42.3484 45.0935 42.0137 45.7704 41.8696C46.4473 41.7256 47.1514 41.7782 47.7993 42.0212C49.4415 42.6328 51.1478 43.057 52.8856 43.2858C53.7648 43.4096 54.5678 43.8516 55.1419 44.5277C55.7159 45.2038 56.0209 46.067 55.9989 46.9529Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c61df58dcf6ad58ae394932b4db7c990.svg";
export { ForwardRef as ReactComponent };